export default function TeamSection() {
  return (
    <section id="team" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Time <span className="text-red-600">IchiBan</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conheça os profissionais dedicados que fazem a diferença no dia a dia da IchiBan Marketing Digital, trabalhando incansavelmente para entregar resultados excepcionais aos nossos clientes.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 max-w-6xl mx-auto">
          <div className="bg-white rounded-3xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="relative mb-8">
              <div className="w-48 h-48 mx-auto rounded-full overflow-hidden border-4 border-red-600 shadow-lg">
                <img
                  src="https://xbqwyqjd.manus.space/jessica_rodrigues.jpeg"
                  alt="Jessica Rodrigues - Head de Marketing Digital da IchiBan"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                Head de Marketing Digital
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2">Jessica Rodrigues</h3>
            <p className="text-red-600 font-semibold mb-4">Head de Marketing Digital</p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Jessica Rodrigues é uma líder inspiradora e dedicada, que se esforça diariamente para gerir o time de marketing digital, otimizar processos e garantir resultados expressivos para os clientes da IchiBan. Sua paixão por inovação e sua capacidade de liderança são fundamentais para o sucesso das campanhas e estratégias da agência.
            </p>

            <div className="flex items-center justify-center space-x-2 text-gray-600 h-6">
              <i className="ri-map-pin-line text-red-600"></i>
              <span className="text-sm">Taubaté, SP</span>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="relative mb-8">
              <div className="w-48 h-48 mx-auto rounded-full overflow-hidden border-4 border-red-600 shadow-lg">
                <img
                  src="https://xbqwyqjd.manus.space/claudiney_ribeiro.png"
                  alt="Claudiney Ribeiro - Head de Projetos da IchiBan"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                Head de Projetos
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2">Claudiney Ribeiro</h3>
            <p className="text-red-600 font-semibold mb-4">Especialista de Marketing Digital</p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Claudiney Ribeiro é o Head de Projetos da IchiBan, um especialista em marketing digital com vasta experiência em gestão de projetos e otimização de resultados. Sua dedicação e conhecimento técnico são cruciais para o sucesso das campanhas e para garantir que os projetos entreguem o máximo valor aos clientes.
            </p>

            <div className="flex items-center justify-center space-x-2 text-gray-600 h-6">
              <i className="ri-map-pin-line text-red-600"></i>
              <span className="text-sm">Jacareí, SP</span>
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:scale-105">
            <div className="relative mb-8">
              <div className="w-48 h-48 mx-auto rounded-full overflow-hidden border-4 border-red-600 shadow-lg">
                <img
                  src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/2e78f8d2637ebeed2e465067415ad61d.jpeg"
                  alt="Igor Gabriel Galindo - Designer Gráfico da IchiBan"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                Designer Gráfico
              </div>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-2">Igor Gabriel Galindo</h3>
            <p className="text-red-600 font-semibold mb-4">Designer Gráfico</p>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Igor Gabriel Galindo é designer com mais de 7 anos de experiência, atuando em projetos de mídias online e offline. Possui sólida vivência em Motion Graphics, participação no desenvolvimento de identidades visuais e na criação de campanhas publicitárias, unindo criatividade, técnica e visão estratégica.
            </p>

            <div className="flex items-center justify-center space-x-2 text-gray-600 h-6">
              <i className="ri-map-pin-line text-red-600"></i>
              <span className="text-sm">Balneário Camboriú, SC</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
